import React, { useState, useEffect } from 'react';
import { Button, Dropdown, Layout, Menu, Space, Spin, Typography } from 'antd';
import { DownOutlined, MenuOutlined, CloseOutlined } from '@ant-design/icons';
import languageStore from '../../store/languageStore';
import { observer } from 'mobx-react-lite';
import './Header.css';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

const { Header } = Layout;
const { Link } = Typography;

const CustomHeaderDesktop = observer(() => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [menuItems, setMenuItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { t } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    languageStore.initialize();
  }, []);

  useEffect(() => {
    const fetchMenuItems = async () => {
      try {
        const response = await fetch('https://api2.praguecoolpass.com/menu');
        const data = await response.json();
        const filteredItems = data.filter(item => item.type === 'section');
        setMenuItems(filteredItems);
      } catch (error) {
        console.error('Error fetching menu items:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchMenuItems();
  }, []);

  const languageMenu = (
    <Menu onClick={({ key }) => languageStore.setLanguage(key)}>
      {languageStore.languages.map((lang) => (
        <Menu.Item key={lang.alpha2code}>{lang.title}</Menu.Item>
      ))}
    </Menu>
  );

  useEffect(() => {
    let lastScrollTop = 0;

    const handleScroll = () => {
      const scrollTop = window.scrollY;

      if (scrollTop > lastScrollTop && scrollTop > 100) {
        setIsScrolled(true);
      } else if (scrollTop < lastScrollTop) {
        setIsScrolled(false);
      }

      lastScrollTop = scrollTop;
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <>
      <Header
      className={isScrolled ? 'header header-scrolled' : 'header header-visible'}
      style={{
        flexDirection: 'row',
        display: 'flex',
        justifyContent: 'center',
        height: '5%',
      }}
    >
      <Menu
        style={{
          backgroundColor: 'transparent',
          justifyContent: 'center',
          color: 'white',
          height: '5%',
          alignItems: 'center',
        }}
        mode="horizontal"
        defaultSelectedKeys={['1']}
      >
        <div className="logo">CoolPass</div>
        {loading ? (
          <Spin />
        ) : (
          menuItems.map((item, index) => (
            <Menu.Item key={index + 1}>
              <Link
                onClick={() => {
                  if (index + 1 === 2) {
                    navigate('/attractions');
                  } else {
                    navigate('/under-construction');
                  }
                }}
                className="header-item-text"
                to={item.link}
              >
                {item.content[languageStore.selectedLanguage].title}
              </Link>
            </Menu.Item>
          ))
        )}
      </Menu>
      <Space>
        <Button
          onClick={() => {
            navigate('/under-construction');
          }}
          type="primary"
          className="custom-button"
        >
          {t('BUY_NOW')}
        </Button>
        {languageStore.loading ? (
          <Spin />
        ) : (
          <Dropdown overlay={languageMenu} trigger={['click']}>
            <Button
              style={{
                backgroundColor: '#252c3e',
                color: 'white',
                border: 'none',
                width: '115px',
                fontSize: '15px',
                height: '35px',
                display: 'flex',
                alignItems: 'center',
                alignSelf: 'center',
                fontWeight: 600,
              }}
            >
              {languageStore.languages.find(
                (lang) => lang.alpha2code === languageStore.selectedLanguage
              )?.title || 'Select Language'}{' '}
              <DownOutlined />
            </Button>
          </Dropdown>
        )}
      </Space>
    </Header>

    </>
  );
});

export default CustomHeaderDesktop;
